import React, { useContext } from 'react';

import * as S from './styles';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsSingleBanner';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import TypeStoreContext from 'context/TypeStoreContext';
import Default from './interfaces/Default';
// import Fashion from './interfaces/Fashion';
// import Grocery from './interfaces/Grocery';

interface SingleBannerProps {
	item: ItemDynamicPageInPhone;
}

export default function SingleBanner({ item }: SingleBannerProps) {
	const { data } = item;
	const { typeStore } = useContext(TypeStoreContext);

	const bannerData: DataFormProps = data;

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return <Default bannerData={bannerData} />;

			case 'grocery':
				return <Default bannerData={bannerData} />;

			case 'fashion':
				return <Default bannerData={bannerData} />;

			default:
				return <Default bannerData={bannerData} />;
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>{returnInterfaceByTypeStore()}</S.container>
	);
}
